import * as React from 'react';

function MoneyIcon(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={32} height={24} viewBox='0 0 32 24' {...props}>
      <g id='_16-Money_Bill' data-name='16-Money Bill' transform='translate(0 -4)'>
        <path
          id='Path_376'
          data-name='Path 376'
          d='M30,4H6A2,2,0,0,0,4,6V8H2a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V24h2a2,2,0,0,0,2-2V6A2,2,0,0,0,30,4ZM26,26H2V10H26Zm4-4H28V10a2,2,0,0,0-2-2H6V6H30Z'
          fill='#003ec4'
        />
        <g id='Group_1091' data-name='Group 1091'>
          <path
            id='Path_377'
            data-name='Path 377'
            d='M14,24a6,6,0,1,0-6-6,6,6,0,0,0,6,6Zm0-10a4,4,0,1,1-4,4,4,4,0,0,1,4-4Z'
          />
          <rect
            id='Rectangle_122'
            data-name='Rectangle 122'
            width={2}
            height={2}
            transform='translate(22 17)'
          />
          <rect
            id='Rectangle_123'
            data-name='Rectangle 123'
            width={2}
            height={2}
            transform='translate(4 17)'
          />
        </g>
      </g>
    </svg>
  );
}
export default MoneyIcon;
